import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { NbToastrService } from '@nebular/theme';
import { ErrorService } from '../../../../../@core/utils/error.service';
import { SessionService } from '../../../../../@core/utils/session.service';
import { Crop } from '../../../models/crop';
import { CropService } from '../../../services/crop.service';

@Component({
  selector: 'crop-details',
  templateUrl: './crop-details.component.html',
  styleUrls: ['./crop-details.component.scss']
})
export class CropDetailsComponent implements OnInit {
//#region Properties
public editActive = false;
public cropLoading = true;
public editCrop: Crop = {};
public submitting: any;
//#endregion

//#region Constructor with Dependencies  
constructor(
  private errorService: ErrorService,
  public dialogRef: MatDialogRef<any>,
  private session: SessionService,
  public cropService: CropService,
  private toastrService: NbToastrService
) {}
//#endregion

ngOnInit() {
  this.editCrop = this.session.selectedCrop;
  if (this.editCrop === null || this.editCrop === undefined) {
    this.editCrop = {};
  }
  if (this.editCrop.id === undefined) {
    this.editCrop.isActive = true;
    this.cropLoading = false;
  }
}

cancelClicked(form: NgForm, cancelled: boolean = false) {
  this.editActive = false;
  this.editCrop = {};
  form.resetForm();
  this.dialogRef.close(cancelled);
}

onSubmit() {
  if (this.editCrop.id) {
    // Close right away and let the list component perform the actual
    // update in the background.
    this.dialogRef.close({
      backgroundSave: true,
      isNew: false,
      crop: { ...this.editCrop }
    });
    return;
  }

  // Close right away and let the list component perform the actual
  // create in the background.
  this.dialogRef.close({
    backgroundSave: true,
    isNew: true,
    crop: { ...this.editCrop }
  });
}
}
